













































import Vue from 'vue';

import { Utils } from '@/Utils';
export default Vue.extend({
    data() {
        return {
            navOpen: false,
        };
    },
    methods: {
        toggleNav() {
            this.navOpen = !this.navOpen;
        },
    },
    computed: {
        inIframe: Utils.inIframe,
    },
});
